import React from "react";
import { Container } from "@material-ui/core";
import { Grid } from "@material-ui/core";

import Heading from '../../Components/sectionHeading'
import tokenomics from '../../images/tokenomics.png'

const PageNotFound = () => {
  return (
    <Container maxWidth="lg">
    <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className="py-5"
    >
        <Grid
            xs={12}
            className="text-center"
        >
        <img src="https://i.imgur.com/qIufhof.png" style={{width: '100%', maxWidth: 500, height: 'auto'}} />
        </Grid>
        <Grid
            xs={12}
            className="text-center"
        >
        <h3 className="text-light">This page could not be found</h3>
        </Grid>
    </Grid>
    </Container>
  );
}

export default PageNotFound;
